import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import TitleGenerator from "./views/RandomTitleGenerator";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/random-title-generator',
            name: 'random-title-generator',
            component: TitleGenerator
        }
    ]
})
